import { createApp } from 'vue'
import PageRisk from './PageRisk.vue'

createApp(PageRisk).mount('#app')
